import {
  Directive,
  Input,
  TemplateRef,
  Output,
  HostListener,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  HostBinding,
} from '@angular/core';
import { EventEmitter } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmModalComponent } from './confirm-modal.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[confirmModal]',
})
export class ConfirmModalDirective implements OnDestroy, OnChanges {
  modal: NgbModalRef;
  modalComponent: ConfirmModalComponent;
  destroy$ = new Subject<void>();
  @Input() disabled: boolean = false;
  @Input() confirmImage: TemplateRef<any>;
  @Input() confirmContent: TemplateRef<any>;
  @Input() confirmContext: any;
  @Input({ alias: 'modal-class' }) className: string;
  @Input() valid: boolean = true;
  @Input() confirmHeader: { icon: string; data: string };
  @Input() openGuard: (() => boolean) | null = null;
  @Output() confirm = new EventEmitter();
  @HostBinding('attr.disabled') get isDisabled() {
    return this.disabled ? '' : null;
  }

  constructor(public modalService: NgbModal) {}

  @HostListener('click') onClick() {
    if (this.disabled) return;
    if (this.openGuard && !this.openGuard()) return;
    this.modal = this.modalService.open(ConfirmModalComponent, {
      size: !!this.confirmImage ? 'lg' : undefined,
      centered: true,
      windowClass: this.className,
    });
    this.modalComponent = this.modal.componentInstance as ConfirmModalComponent;
    this.modalComponent.modalContent = this.confirmContent;
    this.modalComponent.context = this.confirmContext;
    this.modalComponent.imageRef = this.confirmImage;
    this.modalComponent.headerContent = this.confirmHeader;
    this.modalComponent.close.pipe(takeUntil(this.destroy$)).subscribe((x) => this.modal.close(x));
    this.modalComponent.confirm.pipe(takeUntil(this.destroy$)).subscribe((x) => {
      this.confirm.emit(x);
      this.modal.close(x);
    });
  }

  ngOnChanges(_changes: SimpleChanges): void {
    if (!this.valid) {
      this.modal.close();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
